export default __webpack_public_path__ + "static/media/heart-icon-blue.a7d823d7.svg";